import React from 'react';
import PropTypes from 'prop-types';

const Form = ({ className, children, onSubmit }) => (
  <form
    className={className}
    onSubmit={(e) => {
      if (onSubmit) {
        e.preventDefault();

        const formValues = Array.from(e.target.elements).reduce((values, el) => {
          const newValues = { ...values };
          if (el.nodeName === 'INPUT') {
            newValues[el.getAttribute('name')] = el.value;
          } else if (el.nodeName === 'SELECT') {
            newValues[el.getAttribute('name')] = el.options[el.selectedIndex].value;
          }

          return newValues;
        }, {});

        onSubmit(formValues);
      }
    }}
  >
    {children}
  </form>
);

Form.propTypes = {
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string
};

export default Form;
